import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Tokens } from '../models/auth';
import { EmbeddedTokenService } from './embedded-token.service';

@Injectable( {
  providedIn: 'root'
} )
export class EmbeddedAuthService {
  constructor(
    private readonly http: HttpClient,
    private readonly embeddedTokenService: EmbeddedTokenService
  ) {}

  exchangeCode( code: string ): Observable<Tokens> {
    return this.http.post<Tokens>( `${ environment.apiUrl }/identity/exchange`, { code } ).pipe(
      tap( ( tokens ) => {
        this.embeddedTokenService.setTokens( tokens.token, tokens.refreshToken );
      } )
    );
  }

  refreshToken( refreshData: Tokens ): Observable<Tokens> {
    this.embeddedTokenService.clearTokens();

    return this.http.post<Tokens>( `${ environment.apiUrl }/identity/refresh`, refreshData ).pipe(
      tap( ( tokens ) => {
        this.embeddedTokenService.setTokens( tokens.token, tokens.refreshToken );
      } )
    );
  }
}